import { createTheme } from "@mui/material";

export const theme = createTheme({
  components: {
    MuiBadge: {
      styleOverrides: {
        standard: {
          height: "12px",
          minWidth: "12px",
        },
      },
    },
    MuiRating: {
      styleOverrides: {
        icon: {
          borderColor: "white",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "white",
        },
        h1: {
          letterSpacing: "-3px",
          lineHeight: 1.1,
          fontWeight: 500,
        },
        h2: {
          letterSpacing: "-3px",
          lineHeight: 1.1,
          fontWeight: 600,
        },
        h3: {
          letterSpacing: "-3px",
          fontWeight: 600,
        },
        h4: {
          letterSpacing: "-2px",
          fontWeight: 600,
        },
        h6: {
          letterSpacing: "-1px",
          lineHeight: 1.3,
          fontWeight: 400,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        light: {
          borderColor: "#ffffff20",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 100,
          textTransform: "capitalize",
          boxShadow: "none",
        },
        outlined: {
          borderColor: "#ffffff40",
        },
        contained: {
          fontWeight: 600,
        },
        sizeLarge: {
          padding: "16px 42px",
        },
        sizeMedium: {
          padding: "10px 24px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          color: "white",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
          },
          "& input": {
            color: "white",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "rgba(255, 255, 255, 0.7)",
          "&.Mui-focused": {
            color: "white",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "white",
        },
      },
    },
  },
  typography: {
    fontFamily:
      '"Axiforma-Private", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontWeight: 500,
    },
    h2: {
      fontWeight: 500,
    },

    h3: {
      fontSize: 42,
      fontWeight: 500,
    },
  },
  palette: {
    mode: "dark",
    primary: {
      main: "#000000",
      dark: "#ffffff",
    },
    accent: {
      main: "#E4DD60",
      contrastText: "#000000",
    },
    softPrimary: {
      main: "#60D1F620",
      contrastText: "#60D1F6",
    },
    black: {
      main: "#000000",
      contrastText: "#fff",
    },
    white: {
      main: "#ffffff",
      contrastText: "#272934",
    },
    grey: {
      main: "#97B3BD",
    },
  },
});
